/**
 * BizNearYou Translation Helpers for Business Details, Tags, and Explanations.
 * Formats tags, categories, and explanations using built-in translation keys.
 */

import { resolveCanonicalKey, CANONICAL_SIGNALS } from "../config/signalRegistry";
import { AudienceModeId } from "../config/audienceModes";

/**
 * Returns tag label string in clean English source format.
 */
export function translateTag(tag: string, t?: any, audienceMode?: AudienceModeId): string {
  if (!tag) return "";
  const canonicalKey = resolveCanonicalKey(tag);
  if (canonicalKey === "high_competition") {
    const activeMode: AudienceModeId = audienceMode || "job_seeker";
    return CANONICAL_SIGNALS["high_competition"]?.audienceLabels?.[activeMode] || "High Competition";
  }
  return tag;
}

/**
 * Returns category label string in clean English source format.
 */
export function translateCategory(category: string, t?: any): string {
  return category || "";
}

/**
 * Returns stands out bullet item in clean English source format.
 */
export function translateBullet(bullet: string, t?: any): string {
  return bullet || "";
}

/**
 * Returns tag explanation details in clean English source format.
 */
export function translateExplanation(
  exp: { name: string; category?: string; reason: string; source?: string; confidence?: string },
  Business?: any,
  distanceInMiles?: number | null,
  t?: any
): { name: string; category: string; reason: string; source: string; confidence: string } {
  if (!exp) return { name: "", category: "", reason: "", source: "", confidence: "" };

  return {
    name: exp.name || "",
    category: exp.category || "",
    reason: exp.reason || "",
    source: exp.source || "System Intelligence",
    confidence: exp.confidence || "Basic"
  };
}

/**
 * Returns breakdown item string in clean English source format.
 */
export function translateBreakdown(b: string, t?: any): string {
  return b || "";
}
